var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientInfo.loaded)?_c('div',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm._f("NoEmpty")(_vm.clientInfo.shortTitle)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("NoEmpty")(_vm.clientInfo.title)))])])],1):_c('div',[_vm._v(_vm._s(_vm.clientId))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4edf1116","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sales/case/ClientInfo.vue
// module id = null
// module chunks = 